import React from 'react'

const ThinArrow = ({ className, viewBox = "0 -1 20 20", preserveAspectRatio }) => {
    return (
        <svg className={'docs-icon ' + className} width="20" height="20" viewBox={viewBox} preserveAspectRatio={preserveAspectRatio} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.8882 9.26064L10.0083 5.32207L11.1481 4.19922L16.9222 10.0606L11.1481 15.9221L10.0083 14.7992L13.8882 10.8606L3.19922 10.8606V9.26064L13.8882 9.26064Z" />
        </svg>
    )
}

export default ThinArrow;